import {useAppSelector} from "@Hooks/selector/useAppSelector";
import usePairSingleAndReturnAmenityGroups
    from "@CheckOrder/features/amenities/hooks/usePairSingleAndReturnAmenityGroups";
import {
    PairedSingleAndReturnAmenitiesType
} from "@CheckOrder/features/amenities/types/PairedSingleAndReturnAmenities.type";

export default function useGetOpenedAmenityGroup(): PairedSingleAndReturnAmenitiesType {
    const {
        mobileAmenityGroupKey,
    } = useAppSelector((state) => state.mobile)

    const {amenities} = useAppSelector((state) => (state.checkOrder.ticket))
    const {pairedSingleAndReturnAmenities} = usePairSingleAndReturnAmenityGroups(amenities)

    return pairedSingleAndReturnAmenities[mobileAmenityGroupKey]
}